module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'page'),
      expression: "mode === 'page'"
    }],
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.loner.name.caption) + "\n            ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loner && _vm.loner.ogrnip),
      expression: "loner && loner.ogrnip"
    }],
    attrs: {
      "md": "",
      "flat": "",
      "offset": _vm.calcOffset(60, 60)
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c(_vm.renderCompanyFlags(), {
    tag: "v-component"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-end": "",
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.tags), function(tag) {
    return _c('v-chip', {
      key: tag.id,
      attrs: {
        "small": "",
        "disabled": "",
        "text-color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.editNotesDialogOpen()
        }
      }
    }, [_c('span', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n                " + _vm._s(tag.name) + "\n                ")])])
  }), 1)], 1), _vm._v(" "), _c(_vm.createNameComp(_vm.loner), {
    tag: "component"
  }), _vm._v(" "), _c(_vm.createNameShortComp(_vm.loner), {
    tag: "component"
  }), _vm._v(" "), _c('div', [_vm._v("Дата создания: "), _c('b', [_vm._v(_vm._s(_vm.formatDate(_vm.loner.createDate)))])]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatStatus(_vm.loner.status))
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n                ОГРНИП "), _c('b', {
    domProps: {
      "innerHTML": _vm._s(_vm.loner.ogrnip)
    }
  }), _vm._v(" "), _c(_vm.renderCopyButton('Копировать огрнип', _vm.getCompanyOgrnIp), {
    tag: "v-component"
  }), _vm._v("\n                ИНН "), _c('b', {
    domProps: {
      "innerHTML": _vm._s(_vm.renderInnflHtml(_vm.loner.inn))
    }
  }), _vm._v(" "), _c(_vm.renderCopyButton('Копировать инн', _vm.getCompanyInn), {
    tag: "v-component"
  })], 1), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', [_vm._v("\n              Основной вид деятельности: "), _c('b', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.renderFirstActivityHtml(_vm.loner.activities))
    }
  })])]), _vm._v(" "), _c(_vm.createEmailComp(_vm.loner), {
    tag: "component"
  }), _vm._v(" "), _c(_vm.createHeadsComp(_vm.loner.heads), {
    tag: "component"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notesAvailable),
      expression: "notesAvailable"
    }]
  }, [_c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.editNotesDialogOpen()
      }
    }
  }, [_vm._v(_vm._s(_vm.notes ? 'Примечания:' : 'Внесите корпоративные заметки (они будут видны Вашим коллегам).'))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "white-space": "pre-wrap",
      "overflow-wrap": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.notes)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notesAvailable),
      expression: "notesAvailable"
    }]
  }, [_c('v-layout', {
    attrs: {
      "justify-begin": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-chip', {
    attrs: {
      "small": "",
      "disabled": "",
      "text-color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.goDepo()
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "open-delay": "500"
    }
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("storage")])], 1), _vm._v(" "), _c('span', [_vm._v("Перейти в депозитарий")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notesAvailable),
      expression: "notesAvailable"
    }]
  }, [_c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.editNotesDialogOpen()
      }
    }
  }, [_vm._v(_vm._s(_vm.privateNotes ? 'Личные заметки:' : 'Внесите личные заметки (они будут видны только Вам).'))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "white-space": "pre-wrap",
      "overflow-wrap": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.privateNotes)
    }
  })])], 1)], 1)], 1), _vm._v(" "), (_vm.loner && _vm.loner.reference && _vm.loner.reference.ref && _vm.clientCompanyId != null) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-contacts-panel', {
    attrs: {
      "fill-height": "",
      "refCode": _vm.loner.reference.ref
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loner && _vm.loner.reference && _vm.loner.reference.ref && _vm.clientCompanyId != null) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-banks-panel', {
    attrs: {
      "fill-height": "",
      "banks": _vm.banks
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-activities-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loner && _vm.loner.reference),
      expression: "loner && loner.reference "
    }],
    attrs: {
      "fill-height": "",
      "activities": _vm.loner.activities
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-credentinals-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loner && (_vm.loner.tax || _vm.loner.pf || _vm.loner.fss || _vm.loner.registration)),
      expression: "loner && (loner.tax || loner.pf || loner.fss || loner.registration)"
    }],
    attrs: {
      "fill-height": "",
      "reg": _vm.loner.registration,
      "tax": _vm.loner.tax,
      "pf": _vm.loner.pf,
      "fss": _vm.loner.fss
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-loner-licenses-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loner && _vm.loner.reference),
      expression: "loner && loner.reference "
    }],
    attrs: {
      "fill-height": "",
      "items": _vm.loner.licenses
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [(_vm.loner && _vm.loner.reference && _vm.loner.reference.ref && _vm.getProfileHaveClient) ? _c('v-visit-panel', {
    attrs: {
      "fill-height": "",
      "topCount": 5,
      "refCode": _vm.loner.reference.ref
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-loner-records-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loner && _vm.loner.reference),
      expression: "loner && loner.reference "
    }],
    attrs: {
      "fill-height": "",
      "records": _vm.loner.records
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-links-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loner && _vm.loner.ogrnip),
      expression: "loner && loner.ogrnip"
    }],
    attrs: {
      "fill-height": "",
      "inn": _vm.loner.ogrnip
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.loner && _vm.loner.reference) ? _c('v-flex', {
    attrs: {
      "py-1": ""
    }
  }, [_c(_vm.createButton('Ссылка', 'content_copy', 'Копировать ссылку в буфер обмена', _vm.copyLink), {
    tag: "v-component"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loner && _vm.loner.reference && _vm.getProfileHaveClient && !_vm.favoriteLists && !this.accountNameShort) ? _c('v-flex', {
    attrs: {
      "py-1": ""
    }
  }, [_c(_vm.createButton('Контрагент', 'add_circle_outline', 'Добавить контрагента в Мои контрагенты', _vm.addFavorite), {
    tag: "v-component"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loner && _vm.loner.reference && _vm.getProfileHaveClient && _vm.favoriteLists && !this.accountNameShort) ? _c('v-flex', {
    attrs: {
      "py-1": ""
    }
  }, [_c(_vm.createButton('Атрибуты', 'info_outline', 'Атрибуты котрагента в Моих контрагентах', _vm.editNotesDialogOpen), {
    tag: "v-component"
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ad6b09e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/LonerPage.vue
// module id = 1117
// module chunks = 1